const customerEntrypoints = [
  /^\/booking(?:\/[^/]+)?\/?$/,
  /^\/booking\/me\/orders\/[^/]+\/(?:album|gallery|original-album)\/?$/,
  /^\/photo-select\/?$/,
  /^\/(?:chon-anh|album|anh-in)\/[^/]+\/?$/,
  /^\/gallery\/share\/[^/]+\/?$/,
];

export function customerPortalRedirect(currentHref: string, configuredOrigin: string): string | null {
  const current = new URL(currentHref);
  if (!customerEntrypoints.some((pattern) => pattern.test(current.pathname))) return null;
  // The dedicated booking hostname is already the customer destination. The
  // shared ERP bundle must not send its booking pages back to the general
  // service portal, which does not serve this hostname's public-only routes.
  if (current.origin === "https://datlichanhthe.gaonau.com" && current.pathname.startsWith("/booking")) return null;
  if (!configuredOrigin) return null;
  const portal = new URL(configuredOrigin);
  const localHTTP = portal.protocol === "http:" && ["localhost", "127.0.0.1"].includes(portal.hostname);
  if ((portal.protocol !== "https:" && !localHTTP) || portal.username || portal.password ||
      portal.pathname !== "/" || portal.search || portal.hash || portal.origin === current.origin) {
    throw new Error("Invalid CUSTOMER_PORTAL_URL configuration");
  }
  portal.pathname = current.pathname;
  portal.search = current.search;
  portal.hash = current.hash;
  return portal.href;
}
